export const dataConstants = {
	ADDITIONAL_APPT_INFO: 'additional_appt_info',
};

import { requiredString } from '@utils/validation';
import { z } from 'zod';

export const schema = z.object({
	[dataConstants.ADDITIONAL_APPT_INFO]: requiredString(
		'Please provide a response of at least 50 characters',
		50
	),
});
